__turbopack_context__.v({
  "cta-btn": "CTA-module-scss-module__x4p7KW__cta-btn",
  "cta-btn_type__primary": "CTA-module-scss-module__x4p7KW__cta-btn_type__primary",
  "cta-btn_type__primary_inverse": "CTA-module-scss-module__x4p7KW__cta-btn_type__primary_inverse",
  "cta-btn_type__secondary": "CTA-module-scss-module__x4p7KW__cta-btn_type__secondary",
  "cta-btn_type__secondary_inverse": "CTA-module-scss-module__x4p7KW__cta-btn_type__secondary_inverse",
  "cta-btn_variant__orange-filled": "CTA-module-scss-module__x4p7KW__cta-btn_variant__orange-filled",
  "cta-btn_variant__orange-text": "CTA-module-scss-module__x4p7KW__cta-btn_variant__orange-text",
  "cta-btn_variant__plain": "CTA-module-scss-module__x4p7KW__cta-btn_variant__plain",
});
